import React from 'react';
import Skeleton from "@mui/material/Skeleton";

function PaginationSkeleton() {
    const divs = Array.from({ length: 4 }, (_, index) => (
        <div className="ms-1 col-2" key={index}>
            <Skeleton key={index} variant="circular" width={50} height={50}/>
        </div>
    ));

    return (
        <div className="row">
            <div className="col-9"></div>
            <div className="row col-3">{divs}</div>
        </div>
    );
}

export default PaginationSkeleton;